import { render } from "./BalPopover.vue?vue&type=template&id=3295979c"
import script from "./BalPopover.vue?vue&type=script&lang=ts"
export * from "./BalPopover.vue?vue&type=script&lang=ts"

import "./BalPopover.vue?vue&type=style&index=0&id=3295979c&lang=css"
script.render = render

export default script